export default __webpack_public_path__ + "static/media/uploader-abbottNeo-3.52ee3bc5.png";